import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Cada ejercicio es una página aparte en public/biomecanica/. Se abre
// dentro de un marco, como la guía: así el 3D (three.js, ~600 KB) solo
// se descarga cuando alguien entra a un ejercicio, y la app no carga
// ese peso en cada inicio.
const EJERCICIOS = [
  { id: "apertura", nombre: "Apertura", grupo: "Pecho", detalle: "Mancuerna o polea · banco plano o inclinado" },
  { id: "sentadilla", nombre: "Sentadilla", grupo: "Piernas", detalle: "Barra alta, baja o frontal" },
];

export default function Biomecanica({ tema }) {
  const [elegido, setElegido] = useState(null);
  const claro = tema === "claro";

  if (elegido) {
    const ej = EJERCICIOS.find((e) => e.id === elegido);
    return (
      <div className="space-y-2">
        <button onClick={() => setElegido(null)}
          className="flex items-center gap-1 text-sm text-neutral-400 py-1">
          <ChevronLeft size={16} /> Ejercicios
        </button>
        {/* La key con el tema recarga la página al cambiarlo: la página
            lee el tema una sola vez, al abrir. */}
        <iframe key={elegido + (claro ? "c" : "o")}
          src={`/biomecanica/${elegido}.html?tema=${claro ? "claro" : "oscuro"}`}
          title={`Biomecánica: ${ej.nombre}`}
          allow="fullscreen" allowFullScreen
          className="w-full border-0 rounded-xl"
          style={{ height: "calc(100dvh - 190px)", minHeight: 480, background: claro ? "#f5f7fa" : "#171717" }} />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <p className="text-neutral-500 text-xs">
        Tocá un ejercicio para ver cómo trabaja: palancas, esfuerzo y músculos en 3D.
      </p>
      {EJERCICIOS.map((e) => (
        <button key={e.id} onClick={() => setElegido(e.id)}
          className="w-full flex items-center gap-3 p-4 rounded-xl bg-neutral-800 border border-neutral-700 text-left transition-colors hover:border-sky-400">
          <div className="flex-1 min-w-0">
            <p className="text-[10px] uppercase tracking-wide text-sky-400 font-semibold">{e.grupo}</p>
            <p className="font-display font-semibold">{e.nombre}</p>
            <p className="text-xs text-neutral-500 truncate">{e.detalle}</p>
          </div>
          <ChevronRight size={18} className="text-neutral-500 shrink-0" />
        </button>
      ))}
    </div>
  );
}
